import { User } from "@/types/types";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";

export const isFreeUser = (
  stripeSubscriptionId: User["stripeSubscriptionId"]
): boolean => {
  const subscriptionPlan = getSubscriptionPlan(stripeSubscriptionId);

  return subscriptionPlan === "free";
};
